wbApp.controller('SentEmailsEmailDetailCtrl', ['$scope', '$translate', '$filter', 'sentEmailsSvc',
function ($scope, $translate, $filter, sentEmailsSvc) {

    $scope.detailTabs = [
    {
        title: 'TXT_LBL_EMAIL',
        template: "messages/sent-emails-email-detail-content-tab.html"
    }, {
        title: 'TXT_ATTACHMENTS',
        template: "messages/sent-emails-email-detail-attachment-tab.html"
    }, {
        title: 'TXT_COMMUNICATION_HISTORY',
        template: "messages/sent-emails-email-detail-events-tab.html"
    }];

    $scope.subjectHtmlEncoded = "";

    $scope.detail.$promise.then(function (model) {
        $scope.toAddressEmailHtmlEncoded =
            model.toAddress.name + '<' + model.toAddress.email + '>';
        $scope.subjectHtmlEncoded = 'Re: ' + jQuery('<div />').text(model.subject).html();        
        $("#email-content-iframe").contents().find('html').html(model.htmlBody);
    });


}]);
